export function getBase64Image({ id, value }) {
  // 将图片转为base64
  return new Promise((resolve, reject) => {
    var image = new Image()
    // 解决跨域 Canvas 污染问题
    image.setAttribute('crossOrigin', 'anonymous') // 跨域
    image.onload = function() {
      var canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      var context = canvas.getContext('2d')
      context.drawImage(image, 0, 0, image.width, image.height)
      var url = canvas.toDataURL('image/png')
      resolve({
        id,
        value: url
      })
    }
    image.src = value
  })
}
